import React from "react";

const quotes = [
    "In learning you will teach, and in teaching you will learn is what I believe in.",
    "Learning never exhausts the mind.",
    "The beautiful thing about learning is that nobody can take it away from you.",
    "It does not matter how slowly you go as long as you do not stop.",
    "Emotive learning matters more than cognitive learning to me now."
]

export default function About(){
    return(
        <div className="lg:w-[30rem] w-80 overflow-y-scroll min-w-56 h-fit p-4 lg:text-lg text-md">
            Hi, my name is Abhishek Sharma. 
            <br/> <br/>
            I am currently exploring the gigantic software world.&nbsp;I love to learn, unlearn and relearn. 
            &nbsp;And this goes in hand with my passion of teaching. 
            <br/><br/>
            {quotes[Math.floor(Math.random()*quotes.length)]}
            <br/><br/>
            I consider myself an ambivert trying to move a little towards extrovert side of spectrum.
            Years have taught me that human interaction is the best thing that could happen. 

        </div>
    )
}